import environment from '#/environment/environment';
import {getHttpTransportUrl} from '#/utils/get-http-transport-url';
import {CHAIN_NAMESPACES, OPENLOGIN_NETWORK} from '@web3auth/base';
import {EthereumPrivateKeyProvider} from '@web3auth/ethereum-provider';
import {MetamaskAdapter} from '@web3auth/metamask-adapter';
import {Web3AuthNoModal} from '@web3auth/no-modal';
import {OpenloginAdapter} from '@web3auth/openlogin-adapter';
import {Chain} from 'wagmi/chains';

export const getWeb3AuthInstance = (chain: Chain) => {
  const chainConfig = {
    chainNamespace: CHAIN_NAMESPACES.EIP155,
    chainId: '0x' + chain.id.toString(16),
    rpcTarget: getHttpTransportUrl(chain),
    displayName: chain.name,
    tickerName: chain.nativeCurrency?.name,
    ticker: chain.nativeCurrency?.symbol,
    blockExplorerUrl: chain.blockExplorers?.default?.url || '',
  };

  const privateKeyProvider = new EthereumPrivateKeyProvider({
    config: {chainConfig},
  });

  const web3AuthInstance = new Web3AuthNoModal({
    clientId: environment.web3AuthClientId,
    web3AuthNetwork: OPENLOGIN_NETWORK.SAPPHIRE_DEVNET,
    storageKey: 'local',
    chainConfig,
    enableLogging: false,
    sessionTime: 86400,
    privateKeyProvider,
  });

  if (environment.loginOpenLoginEnabled) {
    web3AuthInstance.configureAdapter(
      new OpenloginAdapter({
        adapterSettings: {
          uxMode: 'redirect',
          replaceUrlOnRedirect: false,
        },
        loginSettings: {
          mfaLevel: 'none',
        },
      }),
    );
  }

  if (!!window.ethereum && environment.loginMetamaskEnabled) {
    web3AuthInstance.configureAdapter(new MetamaskAdapter());
  }

  return web3AuthInstance;
};
